
$(document).on("click", ".bootbox-confirm", function (e) {
    var link = $(this).attr("href");
    var titulo = $(this).attr("title");
    e.preventDefault();
    bootbox.confirm({
        title: titulo,
        message: "Confirma Operação: " + titulo + "?",
        centerVertical: true,
        backdrop: true,
        buttons: {
            confirm: {
                label: 'Sim',
                className: 'btn-success'
            },
            cancel: {
                label: 'Não',
                className: 'btn-danger'
            }
        },
        callback: function (result) {
            if (result)
                document.location.href = link;
        }
    });
});

$(document).on("click", ".bootbox-confirm-message", function (e) {
    var link = $(this).attr("href");
    var titulo = $(this).attr("data-title");
    var mensagem = $(this).attr("data-message");
    e.preventDefault();
    bootbox.confirm({
        title: titulo,
        message: mensagem,
        centerVertical: true,
        backdrop: true,
        buttons: {
            confirm: {
                label: 'Sim',
                className: 'btn-success'
            },
            cancel: {
                label: 'Não',
                className: 'btn-light'
            }
        },
        callback: function (result) {
            if (result)
                document.location.href = link;
        }
    });
});

$(document).on("click", ".bootbox-delete", function (e) {
    var link = $(this).attr("href");
    var titulo = $(this).attr("title");
    e.preventDefault();
    bootbox.confirm({
        title: titulo,
        message: "Confirma Exclusão: " + titulo + "?",
        centerVertical: true,
        backdrop: true,
        buttons: {
            confirm: {
                label: 'Sim',
                className: 'btn-danger'
            },
            cancel: {
                label: 'Não',
                className: 'btn-light'
            }
        },
        callback: function (result) {
            if (result)
                document.location.href = link;
        }
    });
});

$(document).on("click", ".bootbox-info", function (e) {
    var titulo = $(this).attr("data-title");
    var mensagem = $(this).attr("data-message");
    e.preventDefault();
    bootbox.alert({
        title: titulo,
        message: mensagem,
        centerVertical: true,
        backdrop: true
    });
});